import { getFilenameFromContentDisposition } from "@/helpers/getFileNameFromContentDisposition";
import { authorizationHeaders } from "@/services/helpers";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import { useCallback, useState } from "react";

interface IProps {
  fileName: string;
  fileExtension: string;
  url: string;
  includeDate: boolean;
}

export const useExport = ({
  fileName,
  fileExtension,
  url,
  includeDate,
}: IProps): [() => void, boolean] => {
  const [isExporting, setIsExporting] = useState<boolean>(false);

  const exportFile: () => void = useCallback(async () => {
    setIsExporting(true);
    const headers = await authorizationHeaders(new Headers());
    const response = await fetch(url, { headers, method: "GET" });
    const blob = await response.blob();
    const contentDisposition = response.headers.get("content-disposition");
    const date = includeDate ? dayjs().format("YYYY-MM-DD") : "";
    const name = contentDisposition
      ? getFilenameFromContentDisposition(contentDisposition)
      : `${fileName}_${date}.${fileExtension}`;
    saveAs(blob, name);
    setIsExporting(false);
  }, [fileName, fileExtension, url, includeDate]);

  return [exportFile, isExporting];
};
